/**
 * Created by René Simon <rene.simon@huchler.it> on 2019-10-03.
 * Copyright © Dr. Huchler und Partner GbR 2019 - present
 */

export const REQUEST_PASSWORD_RESET = 'PASSWORD_FORGOTTEN/REQUEST_PASSWORD_RESET';
export const REQUEST_SET_PASSWORD = 'PASSWORD_FORGOTTEN/REQUEST_SET_PASSWORD';
